module.exports = __webpack_public_path__ + "static/media/video.51ecb0d7.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/TheMoshiDifference/video.mp4
// module id = 176
// module chunks = 0